import { StyleFactory } from '@hscmap/vue-menu';

/** 
 * Fonction de stylisation d'un composant hsc-menu
 * @param variantColor Couleur de variant Bootstrap à appliquer (secondary par défaut)
 * @param textColor Couleur du texte
 * @see https://github.com/michitaro/vue-menu/blob/master/example/src/sample5.vue
 * @see https://github.com/michitaro/vue-menu
 */
export default function HscMenuStyleCustom(variant: string = "secondary", textColor: string = "dark") {
	return StyleFactory ({
		menu: {
			background: 'white',
			color: 'var(--' + textColor + ')',
			boxShadow: '0 2pt 4pt rgba(0, 0, 0, 0.5)'
		},
		menubar: {
			background: 'white',
			color: 'var(--' + textColor + ')',
			boxShadow: '0 4pt 4pt rgba(0, 0, 0, 0.25)'
		},
		active: { backgroundColor: 'var(--' + variant + '-bg-subtle)' },
		disabled: { backgroundColor: 'rgba(127, 127, 127, 0.75)', color: '#fff' },
		separator: { backgroundColor: 'rgba(127, 127, 127, 0.75)', color: '#fff' },
		animation: false
	});
}